import { EDocumentType } from 'src/app/tools/ui/mutilple-file-upload-box/document-type';

export class Document {

    Code: string;
    Name: string;
    CreatedOn: Date;
    CreatedByFullName: string;
    CreatedByPuid: string;
    DocumentType: EDocumentType;
    InterventionCode: string;
    Version: number;
    Reason: string;
    File: File;
    Description: string;

    // UI
    UIDisabled: boolean;
    // !UI

    static mapFromJSON(json: any): Document {
        const doc = new Document();

        doc.Code = json.code;
        doc.Name = json.name;
        doc.CreatedOn = json.createdOn;
        doc.CreatedByFullName = json.createdByFullName;
        doc.CreatedByPuid = json.createdByPuid;
        doc.DocumentType = json.documentType;
        doc.InterventionCode = json.interventionCode;
        doc.Reason = json.reason;
        doc.Version = json.version;
        doc.Description = json.description;

        return doc;
    }
}
